<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/pc_banner_cookie.jpeg`)">
      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          cookieに関して
        </h1>
        <h2 class="update-time">
          最終更新日：2023年11月24日
        </h2>

        <p class="content-p-text">
          cookieなどは、お客様のウェブブラウザに保存される簡易的なテキストで、お客様が当サイトにアクセスした際に、当サイトがお客様を認識できるようにします。
        </p>
        <p class="content-p-text">
          などcookieは、当サイトの運営にとって非常に重要であることに加えて、よりカスタマイズされたサービスをお客様に提供するためにも使用されます。
        </p>
        <p class="content-p-text">
          お客様が当サイトにアクセスした際に、cookieはお客様に関するいくつかの個人情報を収集し、異なるcookieは異なる情報を収集します。
        </p>
        <p class="content-p-text">
          お客様は、パソコンまたはスマートフォンのブラウザ設定を通じて管理ができます。お客様向けのcookieの管理方法の詳細については、以下をご参照ください。お客様がcookieの設定方法をより適切にご利用いただくために、当サイトが使用する各cookieの機能と、これらのcookieを無効にした場合の影響についてお客様にお知らせします。
        </p>
        <h1 class="main-title">
          必要なcookie
        </h1>
        <p class="content-p-text">
          <span class="fw_bold">必要なcookieとは？</span><br>

          これらは当サイトが機能するために必要なcookieです。これらのcookieにより、お客様が当サイトを使用できるようになり、お客様のデバイス上で適切に動作するユーザー再生コンテンツを提供できるようになります。
        </p>
        <p class="content-p-text">
          <span class="fw_bold">当サイトではどのような情報を収集しているのでしょうか？</span><br>これらのcookieはお客様のアカウント、パスワード、ブラウザ設定などの情報を収集しています。
        </p>
        <p class="content-p-text">
          <span class="fw_bold">お客様がこれらのcookieの使用許可しなかった場合、どのような影響が起こるのでしょうか？</span><br>お客様がこれらのcookieの使用を許可しなかった場合、当サイトが正常に動作しない場合があり、一部の内容がお客様の画面上表示されない可能性があります。
        </p>
        <p class="content-p-text">
          勝winはお客様により良い体験をしていただくためにcookieを使用します。以下は当サイトのcookieの用法です。
        </p>
        <ol class="terms-list">
          <li>
            cookieは、当サイトのサービスを向上させるために当サイトへのアクセスを分析するために使用されます。
          </li>
          <li>勝win共有プログラムに関する情報を収集するために使用されます。</li>
          <li>
            プレイヤーがどのように当サイトを移動し、当サイトのサービスを利用するかに関する情報を分析します。
          </li>
          <li>
            これにより、お客様を再訪問者として識別し、お客様により関連性の高いコンテンツを表示できるようになります。
          </li>
          <li>提供されるサービスのスピードアップと強化のため。</li>
          <li>cookieはお客様のチャットサービスをサポートするために使用されます。</li>
        </ol>
        <p class="content-p-text">
          勝winはセッションCookie、永続Cookieを使用します。セッションCookieはログアウト時に期限切れになりますが、永続Cookieは、特定の種類の要件に応じて、1分から数年までブラウザに残ることがあります。
        </p>
        <p class="content-p-text">
          お客様は、ブラウザの設定ページでcookie設定を確認し、有効または無効にするCookieを選択できます。cookieはお客様が使用するブラウザにより異なりますので、詳しくは以下のリンクをご覧ください。
        </p>
        <ul class="list-type-disc ps_2">
          <li>Internet Explorer</li>
          <li>Firefox</li>
          <li>Google Chrome</li>
          <li>Safari</li>
        </ul>
        <p class="content-p-text">
          スマートフォンから当サイトにアクセスする場合は、設定で「cookie」を検索し、設定を管理してください。cookieの削除または制限の詳細については、www.Aboutcookies.org
          をご覧ください。
        </p>
        <p class="content-p-text">
          注意:
          これらのcookieを無効にすると、サイトが適切に機能しなくなり、一部のコンテンツがお客様のデバイスに表示されなくなる可能性があります。
        </p>
      </div>
    <!-- content End -->
    </div>
  <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    footerIframe() {
      return 'https://katsuwin.info/iframe/cookie-policy'
    }
  },
  created() {
  },
  methods: {

  }
}
</script>

